import { useDispatch as useDispatchWithoutTypes } from 'react-redux';
import { type AppDispatch } from '~/store';

export const useDispatch = useDispatchWithoutTypes.withTypes<AppDispatch>();
